import RootLayout from '@/layouts/RootLayout';
import About from '@/pages/About/About';
import Home from '@/pages/Home/Home';
import NotFound from '@/pages/NotFound/NotFound';
import { DocsHubPage, DocsArticlePage } from '@/pages/Docs';
import { SecurityPage } from '@/pages/Security';
import { ProfilePage } from '@sphere/user/feature-profile';
import {
  SettingsLayout,
  PreferencesPage,
  NotificationsPage,
  PrivacyPage,
} from '@/pages/Settings';
import {
  AIDashboard,
  QuizGenerator,
  ClozeQuizGenerator,
  SummaryGenerator,
  ExerciseGenerator,
  QAGenerator,
  CopyGrading,
} from '@/pages/AI';
import Analytics from '@/pages/Analytics/Analytics';
import EstablishmentAnalytics from '@/pages/Analytics/EstablishmentAnalytics';
import { DebugAccessPage, BootstrapDebugPage } from '@/pages/Debug';
import { ProtectedRoute } from './ProtectedRoute';
import { createBrowserRouter } from 'react-router-dom';
import { InstitutionalWrapper } from './InstitutionalWrapper';
import { schoolRoutes } from '@/router/school.routes';
import { activitiesRoutes } from '@/router/activities.routes';
import { learningRoutes } from '@/router/learning.routes';
import { curriculumRoutes } from '@/router/curriculum.routes';
import { adminRoutes } from '@/router/admin.routes';
import { communicationRoutes } from '@/router/communication.routes';
import { NotificationsPage as NotificationsInboxPage } from '@/pages/Notifications';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <InstitutionalWrapper />,
    children: [
      {
        path: '/',
        element: <RootLayout />,
        children: [
          // Routes publiques
          {
            index: true,
            element: (
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            ),
          },
          { path: 'about', element: <About /> },

          // Centre d'aide (filtré par rôle)
          {
            path: 'docs',
            element: (
              <ProtectedRoute>
                <DocsHubPage />
              </ProtectedRoute>
            ),
          },
          {
            path: 'docs/:slug',
            element: (
              <ProtectedRoute>
                <DocsArticlePage />
              </ProtectedRoute>
            ),
          },

          // Sécurité & protection des données (page confiance)
          {
            path: 'security',
            element: (
              <ProtectedRoute>
                <SecurityPage />
              </ProtectedRoute>
            ),
          },

          // Routes protégées - Profile
          {
            path: 'profile',
            element: (
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            ),
          },

          // Routes protégées - Settings
          {
            path: 'settings',
            element: (
              <ProtectedRoute>
                <SettingsLayout />
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                element: <PreferencesPage />,
              },
              {
                path: 'preferences',
                element: <PreferencesPage />,
              },
              {
                path: 'notifications',
                element: <NotificationsPage />,
              },
              {
                path: 'privacy',
                element: <PrivacyPage />,
              },
            ],
          },

          // Routes protégées - AI
          {
            path: 'ai',
            element: (
              <ProtectedRoute>
                <AIDashboard />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/quiz',
            element: (
              <ProtectedRoute>
                <QuizGenerator />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/cloze-quiz',
            element: (
              <ProtectedRoute>
                <ClozeQuizGenerator />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/summary',
            element: (
              <ProtectedRoute>
                <SummaryGenerator />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/exercises',
            element: (
              <ProtectedRoute>
                <ExerciseGenerator />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/qa',
            element: (
              <ProtectedRoute>
                <QAGenerator />
              </ProtectedRoute>
            ),
          },
          {
            path: 'ai/grade-copy',
            element: (
              <ProtectedRoute>
                <CopyGrading />
              </ProtectedRoute>
            ),
          },

          // Routes protégées - Analytics
          {
            path: 'analytics',
            element: (
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            ),
          },
          {
            path: 'analytics/personal',
            element: (
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            ),
          },
          {
            path: 'analytics/establishment',
            element: (
              <ProtectedRoute>
                <EstablishmentAnalytics />
              </ProtectedRoute>
            ),
          },

          // Routes School (établissements, classes, matières, etc.)
          ...schoolRoutes,

          // Routes Curriculum (Référentiels Pédagogiques)
          ...curriculumRoutes,

          // Routes Activities (module Learning)
          ...activitiesRoutes,

          // Routes Communication (annonces, emails, campagnes)
          ...communicationRoutes,

          // Centre de notifications (fil d'annonces utilisateur)
          {
            path: 'notifications',
            element: (
              <ProtectedRoute>
                <NotificationsInboxPage />
              </ProtectedRoute>
            ),
          },

          // Routes Learning (Admin)
          ...learningRoutes,
          // Routes Admin
          ...adminRoutes,

          // Routes de debug (accessibles à tous les utilisateurs connectés)
          {
            path: 'debug/access',
            element: (
              <ProtectedRoute>
                <DebugAccessPage />
              </ProtectedRoute>
            ),
          },
          {
            path: 'debug/bootstrap',
            element: (
              <ProtectedRoute>
                <BootstrapDebugPage />
              </ProtectedRoute>
            ),
          },

          // 404
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
    ],
  },
]);
